import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05ae25a2")

_pushScopeId("data-v-05ae25a2")
const _hoisted_1 = { class: "hd" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "op-l" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_5 = { class: "tit" }
const _hoisted_6 = { class: "type-name" }
const _hoisted_7 = { class: "op-r" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          class: "btn",
          onClick: _ctx.goBack
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("h2", null, [
          _createVNode("span", null, _toDisplayString(_ctx.title), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.questionTypeName), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.onSave)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              plain: "",
              class: "btn",
              onClick: _ctx.handleSave
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})